import { useStore } from '@/store'
import { useEffect } from 'react'

/**
 * Hook para configurar as ferramentas de debug globais
 *
 * Adiciona a função toggleDebugTools() ao window object
 */
export const useDebugTools = () => {
    const toggleDebugTools = useStore(state => state.toggleDebugTools)

    useEffect(() => {
        ;(window as any).toggleDebugTools = toggleDebugTools

        // Função de limpeza para remover a função global quando o hook é desmontado
        return () => {
            delete (window as any).toggleDebugTools
        }
    }, [toggleDebugTools])
}
